/* ER — Collection page enhancements (scoped to .er-collection-grid only)
   - Cursor-follow glow + shine on the premium glass cards (desktop, fine pointer)
   - Honest count-up on the "N products" count (only when a single number)
   - Re-initializes after Dawn's facet AJAX re-renders #ProductGridContainer
   All work is idempotent (data-flags) so re-runs never double-bind or loop. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(pointer: fine)').matches;

  /* ---- Cards: inject glow/shine + wire cursor tracking ---- */
  function initCards(root) {
    var cards = (root || document).querySelectorAll('.er-collection-grid .card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-ercol') === '1') continue;
      card.setAttribute('data-ercol', '1');

      var glow = document.createElement('span');
      glow.className = 'ercol-glow';
      glow.setAttribute('aria-hidden', 'true');
      var shine = document.createElement('span');
      shine.className = 'ercol-shine';
      shine.setAttribute('aria-hidden', 'true');
      card.insertBefore(shine, card.firstChild);
      card.insertBefore(glow, card.firstChild);

      if (fine && !reduce) {
        wireHover(card);
      }
    }
  }

  function wireHover(card) {
    var target = card.closest('.card-wrapper') || card;
    target.addEventListener('pointerenter', function () {
      card.classList.add('is-hover');
    });
    target.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      if (!r.width || !r.height) return;
      card.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      card.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    });
    target.addEventListener('pointerleave', function () {
      card.classList.remove('is-hover');
    });
  }

  /* ---- Product count: count up a single integer, keep the rest of the text ---- */
  function initCount(root) {
    var els = (root || document).querySelectorAll('.er-collection-grid #ProductCountDesktop, .er-collection-grid #ProductCount');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.getAttribute('data-ercol-counted') === '1') continue;
      el.setAttribute('data-ercol-counted', '1');
      countUp(el);
    }
  }

  function countUp(el) {
    var raw = el.textContent;
    var nums = raw.match(/\d[\d,]*/g);
    if (!nums || nums.length !== 1) return; // only the simple "N products" case
    var token = nums[0];
    var target = parseInt(token.replace(/,/g, ''), 10);
    if (isNaN(target) || target <= 0) return;
    var at = raw.indexOf(token);
    var prefix = raw.slice(0, at);
    var suffix = raw.slice(at + token.length);
    if (reduce) return; // SSR value already correct

    // suppress polite announcements of intermediate values while animating
    var live = el.closest('[role="status"]');
    if (live) live.setAttribute('aria-busy', 'true');

    var dur = 900, startTs = null;
    function frame(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 2);
      var v = Math.round(target * eased);
      el.textContent = prefix + v.toLocaleString() + suffix;
      if (p < 1) { requestAnimationFrame(frame); }
      else {
        el.textContent = prefix + target.toLocaleString() + suffix;
        if (live) live.removeAttribute('aria-busy');
      }
    }
    requestAnimationFrame(frame);
  }

  /* ---- Init + re-init on Dawn facet AJAX ---- */
  function initAll() {
    initCards(document);
    initCount(document);
  }

  initAll();

  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      // let Dawn finish swapping innerHTML, then (idempotently) re-init
      requestAnimationFrame(function () {
        pending = false;
        initAll();
      });
    });
    mo.observe(container, { childList: true, subtree: true });
  }
})();
